<script>
import resources from './resources'

export default {
  name: 'professional-specialities-form',
  mixins: [resources]
}
</script>

<template lang="pug">
page(title="Minhas Especialidades", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        .nav-tabs-wrapper
          tab
        .col-xs-12.white-bg
          .row
            .col-xs-12
              div.col-sm-10
                h4 PERFIL PROFISSIONAL — ESPECIALIDADE MÉDICA
                .form-group
                  .row
                    .col-xs-12.col-sm-8.margin-bottom
                      f-select-speciality(label="Especialidade Médica",
                       name="speciality_id",
                       v-model="speciality.speciality_id",
                       :get-all="true",
                       :searchable="true",
                       :disabled="!(!speciality.id)",
                       :errors="errors['speciality_id']")

                    .col-xs-12.col-sm-4.margin-bottom
                      f-text(label="Número RQE"
                      name="rqe",
                      v-model="speciality.rqe",
                      :errors="errors['rqe']")

                  .row
                    .col-xs-12
                      f-file-text(v-if="!speciality.attachment.uuid", label="Anexar RQE"
                       v-model="speciality.attachment",
                       name='attachment',
                       :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                .buttons-wrapper
                  button.btn.save(@click.prevent="doSave()")
                    span.icon 
                    |  Salvar Alterações
</template>



// WEBPACK FOOTER //
// src/app/employee/record/specialities/form/form.vue